import CounterOne from "./components/CounterOne";
import CounterTwo from "./components/CounterTwo";
import CounterThree from "./components/CounterThree";
import Greetings from "./components/Greetings";
import CounterFour from "./components/CounterFour";

function App() {
  return (
    <>
    <CounterOne/>
    <CounterTwo/>
    <CounterThree/>
    <Greetings/>
    <CounterFour/>
    </>
  );
}

export default App;
